// extracted by mini-css-extract-plugin
export var borderRadius = "_dn-4";
export var large = "_dn-3";
export var logoContainer = "_dn-0";
export var nameLogo = "_dn-2";
export var small = "_dn-1";